// extracted by mini-css-extract-plugin
module.exports = {"Content":"SliderContent_Content__3VGcg","firstTitle":"SliderContent_firstTitle__2azgh","secondTitle":"SliderContent_secondTitle__1I7jN","para":"SliderContent_para__ggOta"};